export const styleNames: Record<string, string> = {
  'Aggressive Growth': 'aggressiveGrowth',
  Growth: 'growth',
  GARP: 'garp',
  Value: 'value',
  'Deep Value': 'deepValue',
  Broker: 'broker',
  Yield: 'yield',
  Specialty: 'specialty',
  Alternative: 'alternative',
  'Externally Managed': 'externallyManaged',
  Index: 'index',
  Other: 'other',
  'Private Equity': 'privateEquity',
  'Venture Capital': 'ventureCapital',
  'Cash Equitization': 'cashEquitization'
};
